// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"0bf21d76","258":"5e717d1b","429":"2357d314","436":"ff3dc3bc","462":"a9dc32e0","556":"e53714fb","595":"77cf6c12","613":"5e30aec1","614":"d2a9f494","794":"14710ce2"}[chunkId] + ".chunk.js";
};